import { getToolEnhancement } from "@/data/toolFAQs";
import { HelpCircle, ChevronDown } from "lucide-react";
import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface ToolUsageGuideProps {
  toolId: string;
}

export const ToolUsageGuide = ({ toolId }: ToolUsageGuideProps) => {
  const enhancement = getToolEnhancement(toolId);

  if (!enhancement) return null;

  return (
    <div className="space-y-6">
      {/* How to Use Section */}
      <section className="bg-muted/30 rounded-xl border border-border p-5">
        <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
          <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">?</span>
          How to Use This Tool
        </h3>
        <ol className="space-y-3">
          {enhancement.howToUse.steps.map((step, index) => (
            <li key={index} className="flex gap-3 text-sm">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">
                {index + 1}
              </span>
              <span className="text-muted-foreground pt-0.5">{step}</span>
            </li>
          ))}
        </ol>
      </section>

      {/* FAQ Section */}
      {enhancement.faqs.length > 0 && (
        <section>
          <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
            <HelpCircle className="w-5 h-5 text-primary" />
            Frequently Asked Questions
          </h3>
          <Accordion type="single" collapsible className="space-y-2">
            {enhancement.faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="border border-border rounded-lg px-4 data-[state=open]:bg-muted/30"
              >
                <AccordionTrigger className="text-sm font-medium text-foreground hover:text-primary hover:no-underline py-3">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      )}
    </div>
  );
};
